export default "__VITE_ASSET__CvzlqhE9__"